/* eslint-disable @typescript-eslint/naming-convention */
export class AuthConstants{
  public static readonly AUTH = 'userDataKey';
}
